import { h } from 'preact';
import Page from 'components/pages/page';
import { marked } from 'marked';
import { accessNested } from 'utils/utils';
import { Link } from 'components/core/link/link.js';
import ClosableTrailer from 'components/shared/closableTrailer/closableTrailer';
import s from 'components/pages/text/text.sss';
import HTML from 'components/core/html/html';

import { joinClasses } from 'utils/utils';

marked.use({ breaks: true });

// BASIC TEXT PAGE
// WE SHOULD NOT BE ADDING MORE THINGS LIKE LINK / IMAGE OPTIONS IF POSSIBLE
// (keep the component basic and override if necessary - links and images are doable in markdown)
export default class Text extends Page {

	componentDidMount() {
		if (typeof window.firstSessionVisit === 'undefined') {
			window.firstSessionVisit = true;
		} else {
			window.firstSessionVisit = false;
		}
	}

	getExtraContent() { }

	renderImage() {
		let pageData = this.props.pageData;
		if (!pageData.imageSrc) {
			return;
		}
		return <img src={pageData.imageSrc} class={s.img} alt={pageData.imageAlt} />;
	}

	renderTitle() {
		let pageData = this.props.pageData;
		let titleContent = pageData.title;
		if (!titleContent) {
			return;
		}
		titleContent = this.props.appData.copy[titleContent] || titleContent;
		return <HTML tag="h1" class={s.title} content={titleContent} markdown />;
	}

	renderBody() {
		let pageData = this.props.pageData;
		let bodyContent = pageData.text;
		bodyContent = this.props.appData.copy[bodyContent] || bodyContent || '';
		return <HTML class={s.body} content={bodyContent} markdown />;
	}

	renderLink() {
		let pageData = this.props.pageData;
		if (!pageData.link) {
			return;
		}
		let link = pageData.link;
		let defaultTrackId = 'text_link';
		if (link.linkText) {
			let textSafe = link.linkText.toLowerCase().replace(/[^\w]/g,'').slice(0, 40);
			defaultTrackId = 'text_' + textSafe + '_link';
		}
		let linkTrack = link.trackId || defaultTrackId;

		let linkAttr = {};
		// If the link starts with http or https or //, assume it's an external link
		// Otherwise assume it's a page id
		if (link.path.match(/^(https?:)?\/\//)) {
			linkAttr.href = link.path;
			linkAttr.target = '_blank';
		} else {
			linkAttr.pageId = link.path;
		}

		return (
			<Link
				linkClass={s.textLink}
				trackId={linkTrack}
				{...linkAttr}
			>
				{link.linkText}
			</Link>
		);
	}

	render({ pageData, appData, client }) {
		let { closableTrailer = {} } = pageData;
		let img = this.renderImage();
		let title = this.renderTitle();
		let body = this.renderBody();
		let link = this.renderLink();

		const {
			ytid = '',
			closeText = '',
			overlayText = '',
			src: closingSrc = '',
			vimeoID = '',
			showTT = false,
			thumbSrc = ''
		} = closableTrailer;

		const showClosableTrailer = typeof window !== 'undefined' && window.firstSessionVisit && closableTrailer;

		return (
			<div class={joinClasses(s.wrapper, this.props.id && 'page-component-' + this.props.id)}>
				{showClosableTrailer && (
					<ClosableTrailer
						imgRoot={accessNested(appData, 'urls.roots.imageRegion')}
						ytid={ytid}
						vimeoID={vimeoID}
						closeText={closeText}
						overlayText={overlayText}
						showTT={showTT}
						src={closingSrc}
						client={client}
						activePage={appData.activePage}
						thumbSrc={thumbSrc}
					/>
				)}
				{!pageData.imageBelowText && img}
				{title}
				{body}
				{pageData.imageBelowText && img}
				{link}
				{this.getExtraContent()}
			</div>
		);
	}

}

export const verticallyCenter = true;
